import { useMemo, useRef, useState } from "react";
import Select, { SingleValue, SingleValueProps } from 'react-select';
import { 
    Button, 
    FormFeedback, 
    FormGroup, 
    Input, 
    Modal, 
    ModalBody, 
    ModalHeader 
} from "reactstrap";

type props = {
    onClose: () => void;
    visible: boolean;
    onConfirm: (
        bidID: string, 
        value: string | undefined, 
        note?: string | undefined,
    ) => void;
    bidID: string;
};

type HasShake = {
    shake: () => void;
};

type Ref = Input;

interface ItemArr {
    label: string;
    value: string;
};

const DeleteBidModal = ({ onClose, visible, onConfirm, bidID }: props) => {
    const noteRef = useRef<Ref>(null);
    const [note, setNote] = useState<string>('');
    const [value, setValue] = useState<string>('');
    const [open, setOpen] = useState<boolean>(false);
    const [noteError, setNoteError] = useState<boolean>(false);
    const [items, setItems] = useState<ItemArr[]>([
        {label: 'Purchased From Competitor', value: 'PFC'},
        {label: 'Job Was Canceled', value: 'JWC'},
        {label: 'Lead Time Too Long', value: 'LTL'},
        {label: 'Pricing Issue', value: 'PI'},
        {label: 'Customer Lost Job', value: 'CLJ'},
        {label: 'Other Branch Shipped', value: 'OBS'},
        {label: 'Entered Wrong Account', value: 'EWA'},
        {label: 'Bid Turned into Order', value: 'BTO'},
        {label: 'Testing', value: 'TEST'},
        {label: 'Other', value: 'OTHER'},
    ]);

    const handleSubmit = async () => {
        try {
            if (value !== 'OTHER') {
                onConfirm(bidID, value)

            } else if (!note && value === 'OTHER') {
                setNoteError(true);
                // Toast.show({
                //     type: 'error',
                //     text1: 'Entry Error',
                //     text2: 'Please fill out required fields'
                // });
                return;

            } else {
                onConfirm(bidID, value, note);
            }
        } catch (err: any) {
            console.error('Delete Bid Error:', err.message)
        }
        setValue('');
    }

    const handleClose = () => {
        setValue('');
        setNoteError(false);
        onClose();
    }

    return (
        <Modal
            isOpen={visible}
            onClosed={handleClose}
            fullscreen
            unmountOnClose
        >
            <ModalHeader
                className='bg-primary d-flex justify-content-center'
                style={{ color: 'white', }}
            >
                <Button 
                    title='Close'
                    onClick={onClose}
                    className="bg-transparent border-0 fw-bold text-white position-absolute start-0 ms-2"
                    unmountOnClose
                >
                    Close
                </Button>
                <span 
                    style={{ color: 'white', fontWeight: 'bold', fontSize: 18, }}
                >
                    Delete Bid
                </span>
            </ModalHeader>
            <ModalBody style={{ alignItems: 'center',  marginTop: 10, }}>
                <span className='fw-bold ps-2'>{`Please choose a reason for deleting Bid ${bidID}`}</span>
                <div className="mt-2">
                    <Select 
                        options={items} 
                        onChange={(item) => {
                            if (item?.value) {
                                setValue(item.value)
                            }
                        }}
                    />
                </div>
                <div className="mt-4">
                    {value === 'OTHER' &&
                        <FormGroup>
                            <Input
                                ref={noteRef}
                                for='crmNote'
                                type='textarea'
                                placeholder='Please explain'
                                value={note}
                                bsSize='lg'
                                multiline={true}
                                invalid={noteError}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNote(e.target.value)}
                            />
                            <FormFeedback invalid for='crmNote'>This is a required field</FormFeedback>
                        </FormGroup>
                    }
                </div>
                <div className="text-center">
                    {value &&
                        <Button
                            className="mainButton"
                            style={{ color: 'black', fontWeight: 'bold', }}
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>
                    }
                </div>
            </ModalBody>
        </Modal>
    )
};

export default DeleteBidModal;